// extracted by mini-css-extract-plugin
export var box = "_4x-0";
export var check = "_4x-1";
export var checkboxButton = "_4x-6";
export var checkboxGroup = "_4x-5";
export var disabled = "_4x-7";
export var ghost = "_4x-9";
export var input = "_4x-2";
export var label = "_4x-4";
export var normal = "_4x-8";
export var uncheck = "_4x-3";